module.exports = __webpack_public_path__ + "img/Water pump.ae9ecd35.jpg";